export const SET_COLOR_MODAL_DATA = 'SET_COLOR_MODAL_DATA';
export const CLOSE_COLOR_MODAL = 'CLOSE_COLOR_MODAL';
